import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardImg,
  Col,
  Container,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { imageBaseApi } from "../../../utilis/imageHelper";
import DeleteModal from "../../../Components/Common/DeleteModal";
import DestinationWidgetService from "../../../services/KangarooServices/Intelligence/DestinationWidgetService";
import toast from "react-hot-toast";
import DestinationWidgetForm from "../component/DestinationWidgetForm";

const DestinationWidget = () => {
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState();
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  console.log(
    "🚀 ~ DestinationWidget ~ selectedDeleteItem:",
    selectedDeleteItem,
  );
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isWidgetOpen, setIsWidgetOpen] = useState(false);
  const [isMain, setIsMain] = useState(false);

  const toggleWidget = (item) => {
    setSelectedItem(item);
    setIsWidgetOpen(!isWidgetOpen);
  };

  const [data, setData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await DestinationWidgetService.getList();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    if (item?.destinationCountryId) {
      setIsMain(true);
    } else {
      setIsMain(false);
    }
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        if (isMain === true) {
          await DestinationWidgetService.deleteMain(selectedDeleteItem?.destinationCountryId);
        } else {
          await DestinationWidgetService.delete(selectedDeleteItem);
        }
        fetchData();
        toast.success("Selected item deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Destination Widgets" pageTitle="Widget Setup" />

        <Row className="mb-3">
          <div className="d-flex justify-content-between align-items-center ">
            <button className="btn btn-success" onClick={toggleWidget}>
              <i className="bi bi-plus-lg"></i> Add Widget
            </button>
          </div>{" "}
        </Row>

        <Row xs="1" md="2" lg="3" className="g-4">
          {data?.map((country) => (
            <Col key={country.destinationCountryId}>
              <Card className="h-100 shadow-sm border-0 widget-card">
                {/* Header */}
                <div className="card-header bg-light border-0 d-flex justify-content-between align-items-center">
                  <h6 className="mb-0 fw-semibold">
                    🌍 {country.destinationCountryName}
                  </h6>
                  <span className="badge bg-primary">
                    {country.widgets?.length} Widgets
                  </span>
                </div>

                {/* Body */}
                <CardBody className="">
                  {country.widgets?.length > 0 ? (
                    country.widgets.map((widget) => (
                      <div
                        key={widget.id}
                        className="d-flex gap-3 align-items-start mb-3 rounded widget-item"
                      >
                        {/* Image */}
                        {widget.image?.url && (
                          <img
                            src={`${imageBaseApi}${widget.image.url}`}
                            alt={widget.name}
                            className="rounded"
                            width="55"
                            height="55"
                            style={{ objectFit: "contain" }}
                          />
                        )}

                        {/* Content */}
                        <div className="flex-grow-1">
                          <p className="mb-1 fw-medium">{widget.name}</p>
                          <small className="text-muted">
                            {widget.headingName}
                          </small>
                        </div>
                        <div>
                          <Button
                            size="sm"
                            color="danger"
                            outline
                            onClick={() => handleDeleteClick(widget?.id)}
                          >
                            <i className="ri-delete-bin-5-line"></i>
                          </Button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted text-center mb-0">
                      No widgets available
                    </p>
                  )}
                </CardBody>

                {/* Footer */}
                <CardFooter className="bg-white border-0 pt-0">
                  <div className="d-flex justify-content-end gap-2">
                    {/* <Button
                      size="sm"
                      color="info"
                      outline
                      onClick={() =>
                        navigate(
                          `/destination-widget/${country?.destinationCountryId}`,
                        )
                      }
                    >
                      <i class="ri-eye-line"></i>
                    </Button> */}
                    <Button
                      size="sm"
                      color="warning"
                      outline
                      onClick={() => toggleWidget(country)}
                    >
                      <i className="ri-edit-line"></i>
                    </Button>

                    <Button
                      size="sm"
                      color="danger"
                      outline
                      onClick={() => handleDeleteClick(country)}
                    >
                      <i className="ri-delete-bin-5-line"></i>
                    </Button>
                  </div>
                </CardFooter>
              </Card>
            </Col>
          ))}
        </Row>

        <DestinationWidgetForm
          isOpen={isWidgetOpen}
          toggle={toggleWidget}
          selectedItem={selectedItem}
          fetchData={fetchData}
        />
        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </Container>
    </div>
  );
};

export default DestinationWidget;
